/* tslint:disable */
/* eslint-disable */
/**
 * User API Specification
 * This API specification defines the operations for managing users.
 *
 * The version of the OpenAPI document: 0.11.4
 * Contact: OneIdentityTeam@groups.resmed.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export const CallFactorProfileV1SubTypeEnum = {
    Call: 'CALL'
};
